import React, { useState, useEffect } from 'react';
import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  IonInput,
  IonItem,
  IonList,
  IonButton,
  IonToast,
  IonLabel,
  IonText,
  IonImg,
  IonCard,
  IonFabButton
} from '@ionic/react';
import { connect } from 'react-redux';
import * as actionCreator from '../store/actions/inventoryActions';
import _ from 'lodash';

const AddItemContainer: React.FC = (props: any) => {
  const [name, setName] = useState<string>();
  const [price, setPrice] = useState<number>();
  const [quantity_available, setQuantity_available] = useState<number>();
  const [description, setDescription] = useState<string>();
  const [imageData, setImageData] = useState<any>();
  const [MIMEType, setMIMEType] = useState<string>();

  //handle toast
  const [showToast, setShowToast] = useState(false);
  if (props.updatedItems === false) {
    setTimeout(() => setShowToast(true), 1000);
  }

  useEffect(() => {
    setShowToast(false);
  }, [props.list]);

  function getImage64(e: any) {
    //read image datad
    let data;
    let FR = new FileReader();
    if (e) {
      FR.addEventListener('load', function (e) {
        //@ts-ignore
        data = e.target.result;
        setImageData(data);
      });
      FR.readAsDataURL(e);
      setMIMEType(e.type);
    }
  }

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color="dark">
          <IonTitle>Add Item</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonCard button={true} onClick={()=>{document?.getElementById('itemImage')?.click()}}>
          <IonImg src={ imageData? imageData : "assets/placeholder-image.jpg" }/>
        </IonCard>
        <IonList>          
          <IonItem>
            <IonLabel position="stacked">
              Item Name <IonText color="danger">*</IonText>
            </IonLabel>
            <IonInput
              value={name}
              onIonChange={(e) => setName(e.detail.value!)}
              clearInput
            ></IonInput>
          </IonItem>
          <IonItem>
            <IonLabel position="stacked">
              Price <IonText color="danger">*</IonText>
            </IonLabel>
            <IonInput
              type="number"
              value={price}
              onIonChange={(e) => setPrice(parseInt(e.detail.value!, 10))}
            ></IonInput>
          </IonItem>
          <IonItem>
            <IonLabel position="stacked">
              In Stock <IonText color="danger">*</IonText>
            </IonLabel>
            <IonInput
              type="number"
              value={quantity_available}
              onIonChange={(e) =>
                setQuantity_available(parseInt(e.detail.value!, 10))
              }
            ></IonInput>
          </IonItem>

          <IonItem>
            <IonLabel position="stacked">Description</IonLabel>
            <IonInput
              value={description}
              onIonChange={(e) => setDescription(e.detail.value!)}
              clearInput
            ></IonInput>
          </IonItem>

            <input
              type="file"
              id="itemImage"
              name="img"
              accept="image/*"
              onChange={(e: any) => getImage64(e.target.files[0])}
             hidden />
          {/*  <IonItem style={{hidden}}>
            {!_.isEmpty(imageData) && (
              <img
                src={imageData}
                alt="uploaded item"
                style={{ width: '100vw' }}
              />
            )}
          </IonItem>*/}
         

          <IonButton
            expand="block"
            //@ts-ignore
            disabled={!(name && price && quantity_available && imageData)}
            onClick={() =>
              props.onAddItem({
                name,
                price,
                quantity_available,
                description,
                imageData,
                MIMEType,
                userId: props.user.email,
              })
            }
          >
            {props.info || 'Add item'}
          </IonButton>
          <IonButton expand="block" color="danger" routerLink="/inventory">
            Cancel
          </IonButton>
        </IonList>
      </IonContent>

      <IonToast
        isOpen={showToast}
        message="Success."
        duration={3000}
        position="top"
      />
    </IonPage>
  );
};

const mapStateToProps = (state: any) => {
  return {
    list: state.inventoryReducer.list,
    info: state.inventoryReducer.info,
    updatedItems: state.inventoryReducer.updatedItems,
    user: state.userReducer.user,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    onAddItem: (payload: {}) => dispatch(actionCreator.addItem(payload)),
    onResetStatus: () => dispatch(actionCreator.resetStatus()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddItemContainer);
